module.exports = __webpack_public_path__ + "img/53.d1e5e6be.png";